import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "团队日报详情"
};
const _hoisted_2 = {
  class: "absolute inset-y-0 right-0 flex h-full w-full max-w-4xl flex-col bg-slate-50 shadow-2xl sm:w-[92vw] lg:w-[860px]"
};
const _hoisted_3 = {
  class: "flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 bg-white px-5 py-4 sm:px-6"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  class: "flex h-10 w-10 items-center justify-center rounded-full bg-blue-50 text-sm font-semibold text-blue-600"
};
const _hoisted_6 = {
  class: "min-w-0"
};
const _hoisted_7 = {
  class: "truncate text-lg font-semibold text-slate-900"
};
const _hoisted_8 = {
  class: "mt-0.5 text-sm text-slate-500"
};
const _hoisted_9 = {
  key: 0,
  class: "mt-2 flex flex-wrap gap-1.5"
};
const _hoisted_10 = {
  class: "status-badge is-neutral"
};
const _hoisted_11 = {
  key: 1,
  class: "mt-2 text-xs leading-5 text-slate-500"
};
const _hoisted_12 = {
  class: "shrink-0 overflow-x-auto border-b border-slate-200 bg-white px-4 sm:px-6",
  role: "tablist",
  "aria-label": "日报详情内容"
};
const _hoisted_13 = {
  class: "flex min-w-max gap-1 pb-0.5"
};
const _hoisted_14 = ["aria-selected", "onClick"];
const _hoisted_15 = {
  class: "min-h-0 flex-1 overflow-y-auto px-4 py-5 sm:px-6"
};
const _hoisted_16 = {
  key: 0,
  class: "data-table-empty is-compact"
};
const _hoisted_17 = {
  key: 1,
  class: "space-y-8"
};
const _hoisted_18 = {
  key: 0,
  class: "absolute inset-0 z-20 flex items-center justify-center p-4",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "待办批注"
};
const _hoisted_19 = {
  class: "relative flex max-h-[82vh] w-full max-w-xl flex-col overflow-hidden rounded-xl bg-white shadow-2xl"
};
const _hoisted_20 = {
  class: "flex shrink-0 items-start justify-between gap-3 border-b border-slate-100 px-5 py-4"
};
const _hoisted_21 = {
  class: "min-w-0"
};
const _hoisted_22 = {
  class: "flex items-center gap-2 text-base font-semibold text-slate-900"
};
const _hoisted_23 = {
  class: "mt-1 truncate text-sm text-slate-500"
};
const _hoisted_24 = {
  class: "min-h-0 flex-1 overflow-y-auto px-5 py-4"
};
const _hoisted_25 = {
  key: 0,
  class: "flex items-center justify-center gap-2 py-12 text-sm text-slate-500"
};
const _hoisted_26 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-12 text-center"
};
const _hoisted_27 = {
  key: 2,
  class: "rounded-lg border border-dashed border-slate-200 px-4 py-8 text-center text-sm text-slate-400"
};
const _hoisted_28 = {
  key: 3,
  class: "space-y-3"
};
const _hoisted_29 = {
  class: "flex flex-wrap items-center justify-between gap-2 text-xs text-slate-400"
};
const _hoisted_30 = {
  class: "font-medium text-slate-600"
};
const _hoisted_31 = {
  class: "mt-1.5 whitespace-pre-wrap break-words text-sm leading-6 text-slate-700"
};
const _hoisted_32 = {
  key: 0,
  class: "shrink-0 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_33 = {
  class: "block"
};
const _hoisted_34 = {
  class: "mt-3 flex justify-end gap-2"
};
const _hoisted_35 = ["disabled"];
const _hoisted_36 = ["disabled"];
const _hoisted_37 = {
  key: 1,
  class: "shrink-0 border-t border-slate-100 bg-slate-50 px-5 py-3 text-xs text-slate-500"
};
import { computed, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { ChatBubbleLeftRightIcon, ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { addWorkItemTodoAnnotation, listWorkItemTodoAnnotations } from '@/api/workReport';
import ReportCommentPanel from './ReportCommentPanel.vue';
import ReportComparisonPanel from './ReportComparisonPanel.vue';
import ReportEvaluationPanel from './ReportEvaluationPanel.vue';
import ReportEvaluationSummary from './ReportEvaluationSummary.vue';
import { workReportStatusMeta } from '../workReportUtils';
export default {
  __name: 'ReportDetailDrawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    canEvaluate: {
      type: Boolean,
      default: false
    },
    canRequestSupplement: {
      type: Boolean,
      default: false
    },
    canComment: {
      type: Boolean,
      default: false
    },
    evaluationSubmitting: {
      type: Boolean,
      default: false
    },
    supplementSubmitting: {
      type: Boolean,
      default: false
    },
    operationSubmitting: {
      type: Boolean,
      default: false
    },
    supplementResetToken: {
      type: Number,
      default: 0
    },
    selectedVersion: {
      type: Object,
      default: null
    },
    versionLoading: {
      type: Boolean,
      default: false
    },
    initialTab: {
      type: String,
      default: 'comparison'
    },
    focusCommentId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue', 'evaluate', 'request-supplement', 'comment', 'select-version'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const activeTab = ref('comparison');
    const showTodoAnnotationModal = ref(false);
    const todoAnnotationLoading = ref(false);
    const todoAnnotationSubmitting = ref(false);
    const todoAnnotationError = ref(false);
    const todoAnnotationWorkItem = ref(null);
    const todoAnnotations = ref([]);
    const todoAnnotationContent = ref('');
    const hasComments = computed(() => props.detail?.comments?.length > 0);
    const hasEvaluations = computed(() => props.detail?.evaluations?.length > 0);
    const canAddTodoAnnotation = computed(() => Boolean(props.detail?.id && todoAnnotationWorkItem.value?.id && todoAnnotationWorkItem.value?.todoId && todoAnnotationWritable(todoAnnotationWorkItem.value)));
    const shouldShowEvaluationTab = computed(() => props.canEvaluate || hasEvaluations.value || props.initialTab === 'evaluation');
    const shouldShowCommentTab = computed(() => hasComments.value || props.canComment || props.canRequestSupplement || props.initialTab === 'comments' || Boolean(props.focusCommentId));
    const detailContext = computed(() => props.detail?.detailContext || {});
    const statusSummary = computed(() => props.detail?.statusSummary || {});
    const phaseVersions = computed(() => Array.isArray(props.detail?.phaseVersions) ? props.detail.phaseVersions : []);
    const availableTabs = computed(() => {
      const tabs = [{
        value: 'comparison',
        label: '日报内容'
      }];
      if (shouldShowEvaluationTab.value) tabs.splice(1, 0, {
        value: 'evaluation',
        label: '评价'
      });
      if (shouldShowCommentTab.value) tabs.push({
        value: 'comments',
        label: '评论与补充'
      });
      return tabs;
    });
    const sourceLabel = computed(() => {
      if (detailContext.value.source === 'COPIED_TO_ME') return '抄送我的';
      if (detailContext.value.source === 'TEAM') return '直属团队';
      return '我的日报';
    });
    const readonlyHint = computed(() => detailContext.value.readOnly ? detailContext.value.viewHint || '该日报仅支持查看' : '');
    const statusSummaryBadges = computed(() => {
      const summary = statusSummary.value;
      const badges = [{
        key: 'planStatus',
        label: `计划：${statusLabel(summary.planStatus || props.detail?.planStatus)}`,
        class: statusClass(summary.planStatus || props.detail?.planStatus)
      }, {
        key: 'summaryStatus',
        label: `总结：${statusLabel(summary.summaryStatus || props.detail?.summaryStatus)}`,
        class: statusClass(summary.summaryStatus || props.detail?.summaryStatus)
      }];
      if (summary.planLate || summary.summaryLate) badges.push({
        key: 'late',
        label: '存在迟交',
        class: 'status-badge is-warning'
      });
      if (summary.planMissing || summary.summaryMissing) badges.push({
        key: 'missing',
        label: '存在缺交',
        class: 'status-badge is-rose'
      });
      if (summary.awaitingEvaluation) badges.push({
        key: 'awaitingEvaluation',
        label: '待评价',
        class: 'status-badge is-info'
      });
      if (summary.supplementRequested) badges.push({
        key: 'supplementRequested',
        label: '待补充',
        class: 'status-badge is-orange'
      });
      return badges;
    });
    const reportTitle = computed(() => {
      const employee = props.detail?.employee;
      return props.detail?.employeeName || employee?.name || employee?.realName || '团队日报详情';
    });
    const userInitials = computed(() => {
      const name = reportTitle.value;
      if (name === '团队日报详情') return '?';
      return name.slice(0, 2).toUpperCase();
    });
    watch(() => props.modelValue, visible => {
      if (visible) activeTab.value = props.initialTab || 'comparison';
    });
    watch(() => props.initialTab, tab => {
      if (props.modelValue && tab) activeTab.value = tab;
    });
    watch(availableTabs, tabs => {
      if (props.modelValue && props.initialTab && tabs.some(tab => tab.value === props.initialTab)) {
        activeTab.value = props.initialTab;
        return;
      }
      if (!tabs.some(tab => tab.value === activeTab.value)) activeTab.value = 'comparison';
    });
    function closeDrawer() {
      emit('update:modelValue', false);
    }
    function requestSupplement(payload) {
      if (!props.canRequestSupplement) return;
      const content = String(payload?.content || '');
      const normalizedContent = content.trim();
      if (!normalizedContent) return;
      emit('request-supplement', {
        content: normalizedContent
      });
    }
    function submitComment(comment) {
      if (!props.canComment) return;
      emit('comment', comment);
    }
    async function openTodoAnnotations(item) {
      if (!props.detail?.id || !item?.id || !item?.todoId) return;
      todoAnnotationWorkItem.value = item;
      todoAnnotationContent.value = '';
      showTodoAnnotationModal.value = true;
      await loadTodoAnnotations();
    }
    async function loadTodoAnnotations() {
      const item = todoAnnotationWorkItem.value;
      if (!props.detail?.id || !item?.id) return;
      todoAnnotationLoading.value = true;
      todoAnnotationError.value = false;
      try {
        const result = await listWorkItemTodoAnnotations(props.detail.id, item.id);
        todoAnnotations.value = normalizeCollection(result);
      } catch {
        todoAnnotationError.value = true;
        ElMessage.error('待办批注加载失败，请重试');
      } finally {
        todoAnnotationLoading.value = false;
      }
    }
    function closeTodoAnnotationModal() {
      showTodoAnnotationModal.value = false;
      todoAnnotationLoading.value = false;
      todoAnnotationSubmitting.value = false;
      todoAnnotationError.value = false;
      todoAnnotationWorkItem.value = null;
      todoAnnotations.value = [];
      todoAnnotationContent.value = '';
    }
    async function submitTodoAnnotation() {
      const content = todoAnnotationContent.value.trim();
      const item = todoAnnotationWorkItem.value;
      if (!content || !props.detail?.id || !item?.id || !canAddTodoAnnotation.value) return;
      todoAnnotationSubmitting.value = true;
      try {
        await addWorkItemTodoAnnotation(props.detail.id, item.id, {
          content
        });
        todoAnnotationContent.value = '';
        ElMessage.success('批注已同步');
        await loadTodoAnnotations();
      } catch {
        ElMessage.error('批注提交失败，请重试');
      } finally {
        todoAnnotationSubmitting.value = false;
      }
    }
    function todoAnnotationWritable(item) {
      const writable = item?.todoAnnotationWritable ?? item?.todoAnnotationCanWrite ?? item?.canAddTodoAnnotation ?? item?.currentTodoSnapshot?.todoAnnotationWritable ?? item?.todoSnapshot?.todoAnnotationWritable;
      return Boolean(writable);
    }
    function normalizeCollection(value) {
      if (Array.isArray(value)) return value;
      return value?.records || value?.list || value?.rows || value?.data || [];
    }
    function statusLabel(status) {
      return workReportStatusMeta(status).label;
    }
    function statusClass(status) {
      if (status === 'SUBMITTED') return 'status-badge is-success';
      if (status === 'MISSING') return 'status-badge is-rose';
      if (status === 'LATE') return 'status-badge is-warning';
      return 'status-badge is-neutral';
    }
    return (_ctx, _cache) => {
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/40",
        onClick: closeDrawer
      }), _createElementVNode("aside", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(userInitials.value), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("h2", _hoisted_7, _toDisplayString(reportTitle.value), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(__props.detail?.reportDate || '--'), 1), __props.detail ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(sourceLabel.value), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusSummaryBadges.value, badge => {
        return _openBlock(), _createElementBlock("span", {
          key: badge.key,
          class: _normalizeClass(["status-badge", badge.class])
        }, _toDisplayString(badge.label), 3);
      }), 128))])) : _createCommentVNode("", true), readonlyHint.value ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(readonlyHint.value), 1)) : _createCommentVNode("", true)])]), _createElementVNode("button", {
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
        title: "关闭详情",
        "aria-label": "关闭详情",
        onClick: closeDrawer
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-5 w-5"
      })])]), _createElementVNode("nav", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTabs.value, tab => {
        return _openBlock(), _createElementBlock("button", {
          key: tab.value,
          type: "button",
          role: "tab",
          class: _normalizeClass(["rounded-t-md px-3 py-2.5 text-sm font-medium transition-all duration-200", activeTab.value === tab.value ? 'bg-slate-50 text-slate-900' : 'text-slate-500 hover:text-slate-700']),
          "aria-selected": activeTab.value === tab.value,
          onClick: $event => activeTab.value = tab.value
        }, _toDisplayString(tab.label), 11, _hoisted_14);
      }), 128))])]), _createElementVNode("div", _hoisted_15, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_16, "正在加载日报详情...")) : __props.detail ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [activeTab.value === 'comparison' ? (_openBlock(), _createBlock(ReportComparisonPanel, {
        key: 0,
        report: __props.detail,
        versions: phaseVersions.value,
        "selected-version": __props.selectedVersion,
        "loading-version": __props.versionLoading,
        onSelectVersion: _cache[0] || (_cache[0] = $event => emit('select-version', $event)),
        onOpenAnnotations: openTodoAnnotations
      }, null, 8, ["report", "versions", "selected-version", "loading-version"])) : _createCommentVNode("", true), activeTab.value === 'evaluation' ? (_openBlock(), _createElementBlock("div", _hoisted_17, [__props.canEvaluate ? (_openBlock(), _createBlock(ReportEvaluationPanel, {
        key: 0,
        report: __props.detail,
        submitting: __props.evaluationSubmitting,
        disabled: __props.operationSubmitting,
        onSubmit: _cache[1] || (_cache[1] = $event => emit('evaluate', $event))
      }, null, 8, ["report", "submitting", "disabled"])) : (_openBlock(), _createBlock(ReportEvaluationSummary, {
        key: 1,
        evaluations: __props.detail.evaluations
      }, null, 8, ["evaluations"]))])) : _createCommentVNode("", true), activeTab.value === 'comments' ? (_openBlock(), _createBlock(ReportCommentPanel, {
        key: 2,
        comments: __props.detail.comments,
        disabled: __props.operationSubmitting,
        "can-submit": __props.canComment,
        "can-request-supplement": __props.canRequestSupplement,
        "focus-comment-id": __props.focusCommentId,
        onSubmit: submitComment,
        onRequestSupplement: requestSupplement
      }, null, 8, ["comments", "disabled", "can-submit", "can-request-supplement", "focus-comment-id"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]), showTodoAnnotationModal.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/30",
        onClick: closeTodoAnnotationModal
      }), _createElementVNode("section", _hoisted_19, [_createElementVNode("header", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("h3", _hoisted_22, [_createVNode(_unref(ChatBubbleLeftRightIcon), {
        class: "h-5 w-5 text-blue-500"
      }), _cache[3] || (_cache[3] = _createTextVNode(" 待办批注 ", -1))]), _createElementVNode("p", _hoisted_23, _toDisplayString(todoAnnotationWorkItem.value?.title || todoAnnotationWorkItem.value?.todoSnapshot?.title || '--'), 1)]), _createElementVNode("button", {
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
        title: "关闭",
        "aria-label": "关闭",
        onClick: closeTodoAnnotationModal
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-5 w-5"
      })])]), _createElementVNode("main", _hoisted_24, [todoAnnotationLoading.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
        class: "app-spinner is-sm"
      }, null, -1), _createTextVNode(" 正在加载批注... ", -1)]))])) : todoAnnotationError.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_unref(ExclamationTriangleIcon), {
        class: "h-8 w-8 text-rose-400"
      }), _cache[5] || (_cache[5] = _createElementVNode("p", {
        class: "text-sm text-slate-500"
      }, "批注加载失败，请重试。", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: loadTodoAnnotations
      }, "重试")])) : !todoAnnotations.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 暂无批注 ")) : (_openBlock(), _createElementBlock("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(todoAnnotations.value, annotation => {
        return _openBlock(), _createElementBlock("div", {
          key: annotation.id || annotation.createTime || annotation.content,
          class: "rounded-lg border border-slate-100 bg-slate-50/70 px-3.5 py-3"
        }, [_createElementVNode("div", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(annotation.creatorName || annotation.createByName || annotation.authorName || '未知用户'), 1), _createElementVNode("span", null, _toDisplayString(annotation.createTime || annotation.createdAt || ''), 1)]), _createElementVNode("p", _hoisted_31, _toDisplayString(annotation.content || annotation.remark || '--'), 1)]);
      }), 128))]))]), canAddTodoAnnotation.value ? (_openBlock(), _createElementBlock("footer", _hoisted_32, [_createElementVNode("label", _hoisted_33, [_cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "form-label"
      }, "新增批注", -1)), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => todoAnnotationContent.value = $event),
        class: "form-textarea form-control-sm mt-1 w-full",
        rows: "3",
        maxlength: "1000",
        placeholder: "请输入批注内容"
      }, null, 512), [[_vModelText, todoAnnotationContent.value]])]), _createElementVNode("div", _hoisted_34, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        disabled: todoAnnotationSubmitting.value,
        onClick: closeTodoAnnotationModal
      }, "取消", 8, _hoisted_35), _createElementVNode("button", {
        type: "button",
        class: "btn-primary",
        disabled: todoAnnotationSubmitting.value || !todoAnnotationContent.value.trim(),
        onClick: submitTodoAnnotation
      }, _toDisplayString(todoAnnotationSubmitting.value ? '提交中' : '提交批注'), 9, _hoisted_36)])])) : todoAnnotationWorkItem.value?.todoId ? (_openBlock(), _createElementBlock("footer", _hoisted_37, " 仅待办负责人或创建人可新增批注。 ")) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])), [[_directive_modal_a11y, closeDrawer]]) : _createCommentVNode("", true)]);
    };
  }
};